module.exports = __webpack_public_path__ + "img/04.2eeead5d.jpg";